import api from '..';

export const postDay1TransferRequest = (payload) => {
  return api.post('/day1/transferUser', payload);
};

export const getDay1TransferredUserRequest = (payload) => {
  return api.get('/day1/transferedUserById', { params: payload });
};
